import React from 'react';
import { paymentDays } from './InvoicePrintDetails';
export default function InvoicePrintFooter({doc, fmt2}) {
  const d = doc.print_details || {};
  const cell = {border:'1px solid #000',padding:'4px 8px',verticalAlign:'top'};
  const shipping = [['Delegat',d.delegate_name],['BI/CI', [d.delegate_series,d.delegate_number].filter(Boolean).join(' ')],['Mijloc de transport',d.transport],['Nr. înmatriculare',d.registration]].filter(([,value])=>value);
  const days = paymentDays(doc);
  return <table style={{width:'100%',borderCollapse:'collapse',marginTop:5}}><tbody>
    <tr><td style={cell} colSpan={2}>Condiții de plată: <b>{d.payment_method==='Altă variantă' ? (d.payment_other || 'Altă variantă') : (d.payment_method || 'OP')}</b>
      {doc.bxdatascadenta && <> · Scadență: <b>{String(doc.bxdatascadenta).slice(0,10).split('-').reverse().join('.')}</b></>}
      {days!=='' && <> · Termen de plată: <b>{days} zile</b></>}
      {d.penalty_percent !== '' && d.penalty_percent != null && Number(d.penalty_percent)>0 && <> · Penalizări: <b>{d.penalty_percent}% / zi</b></>}
    </td></tr>
    <tr><td style={{...cell,width:'65%'}}>
      {(d.prepared_by || doc.user_name) && <div>Întocmit de: <b>{d.prepared_by || doc.user_name}</b></div>}
      {shipping.map(([label,value])=><div key={label}>{label}: <b>{value}</b></div>)}
    </td><td style={cell}>
      <div>Total fără TVA: <b>{fmt2(doc.bxvalftva)}</b></div>
      <div>TVA: <b>{fmt2(doc.bxvaltva)}</b></div>
      <div className="mt-2" style={{fontSize:14}}>Total de plată: <b>{fmt2(doc.bxtotalwtva)}</b></div>
    </td></tr>
  </tbody></table>;
}
